import React, {Component} from 'react'
import PropTypes from 'prop-types'
import _s from 'lodash/string'

class MoreLess extends Component {
  constructor(props) {
    super(props)
    this.state = {
      initialText: this.props.proxy.querySelector('.more-less-text').innerHTML,
      shortText: '',
      open: false,
      openable: null
    }
  }

  componentDidMount() {
    this.init()
  }

  componentDidUpdate() {
    if (this.moreButton)
      this.moreButton.style.display = !this.state.openable || this.state.open ? "none" : 'block'
    if (this.lessButton)
      this.lessButton.style.display = !this.state.openable || !this.state.open ? "none" : 'block'
    this.text = !this.state.openable || this.state.open ? this.state.initialText : this.state.shortText
  }

  get moreButton() {
    return this.props.proxy.querySelector('.inline-button.more')
  }

  get lessButton() {
    return this.props.proxy.querySelector('.inline-button.less')
  }

  init() {
    if (this.moreButton)
      this.moreButton.addEventListener("click", (e) => this.setState({open: true}), false)

    if (this.lessButton)
      this.lessButton.addEventListener("click", (e) => this.setState({open: false}), false)

    let text = this.state.initialText
    let split = _s.trim(text).split(' ')
    if (this.props.words && split.length > parseInt(this.props.words)) {
      this.setState({openable: true, shortText: split.splice(0, parseInt(this.props.words)).join(' ') + "..."})
    } else if (this.props.limit && text.length > this.props.limit) {
      this.setState({openable: true, shortText: text.substring(0, this.props.limit - 1) + "..."})
    } else {
      this.setState({openable: false})
    }
  }

  set text(v) {
    this.props.proxy.querySelector('.more-less-text').innerHTML = v
  }

  render() {
    return <div></div>
  }
}

MoreLess.types = {
  limit: PropTypes.number,
  words: PropTypes.number
}

export default (MoreLess)


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/more-less/MoreLess.js